const NAME = "FILTERS_DIALOG";

export default NAME;
